import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { compose, getContext, withBeacon, withTranslation } from '@hocs'
import { trackingShareProperty } from '@app-core/beacon/beacon'
import { PlaceType } from '@app-core/place/reducer'
import GhostBannerContainer from '../GhostBannerContainer'
import { goBackTo } from '@libs/appUrl'

import Sticky from 'react-stickynode'

import cx from 'classnames'
import styles from './PlaceImageBlock.scss'
import { PageContext } from '@libs/pageContext'
import dynamic from 'next/dynamic'

// 使用到 `react-slick` 不支援 SSR
const CarouselImageList = dynamic(() => import('@components/CarouselImageList'), { ssr: false })

class PlaceImageBlock extends Component {
  static contextType = PageContext

  state = {
    active: false,
  }

  componentDidMount() {
    window.addEventListener('scroll', this._handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this._handleScroll)
  }

  _handleScroll = () => {
    const placeInfo = document.querySelectorAll('.place__info')
    if (placeInfo.length > 0 && window.scrollY > placeInfo[0].offsetTop) {
      this.setState({ active: true })
    } else {
      this.setState({ active: false })
    }
  }

  render() {
    const { active } = this.state
    const { placeData, isApp, placeType } = this.props
    const isChoice = placeType === PlaceType.choice
    const isGhost = placeType === PlaceType.ghost
    const className = cx('carousel', { ghost: isGhost })
    const controlBoxClassName = cx('carousel__controlBox', { active })
    const backBtnStyle = this.context.hideNavbar
      ? { visibility: 'hidden' }
      : { visibility: isApp ? 'visible' : 'hidden' }
    const stickyTop = isApp ? 0 : 52
    return (
      <div className={className}>
        <style jsx>{styles}</style>
        <Sticky top={stickyTop}>
          <div
            key="ctrBox"
            ref={(node) => (this.ctrBox = this.ctrBox || node)}
            className={controlBoxClassName}
          >
            <div
              className="carousel__btn carousel__btn--backButton"
              onClick={this._onClickBack}
              style={backBtnStyle}
            />
            <div
              className="carousel__title"
              style={this.context.hideNavbar ? { visibility: 'hidden' } : undefined}
            >
              {placeData.place.name}
            </div>
            <div
              className="carousel__btn carousel__btn--shareButton"
              onClick={this._onClickedMore}
            />
          </div>
        </Sticky>
        {isChoice && (
          <div className="carousel__slider">
            <CarouselImageList
              images={placeData.img || []}
              renderCaption={this._renderCaption}
              onClickOpenImageModal={this._onClickOpenImageModal}
            />
          </div>
        )}
        {isGhost && <GhostBannerContainer placeId={placeData.postID} />}
      </div>
    )
  }

  igLink = ({ link = '', name = '' }) => {
    if (link) return `https://www.instagram.com/p/${link.trim()}`
    if (name) return `https://www.instagram.com/${name.trim().replace(/^@/gi, '')}`
  }

  _renderCaption = (index) => {
    const { t, placeData } = this.props
    return (
      <div className="carousel__captions">
        {placeData.img[index].name && (
          <a
            className="carousel__source"
            href={this.igLink(placeData.img[index])}
            target="_blank"
            rel="noopener noreferrer"
            onClick={this._onClickImageSource}
          >
            {`${t('圖片來源：')} ${placeData.img[index].sourceType} ${placeData.img[index].name}`}
          </a>
        )}
        <div className="carousel__pagination">
          <span className="carousel__currentPage">{index + 1}</span>/
          <span className="carousel__totalPages">{placeData.img.length}</span>
        </div>
      </div>
    )
  }

  _onClickBack = () => goBackTo()

  _onClickedMore = () => this.props.onClickedMore()

  _onClickOpenImageModal = () => {
    const { placeData, amplitudeEventTrack } = this.props
    amplitudeEventTrack('click.top.images', trackingShareProperty(placeData))
  }

  _onClickImageSource = (e) => {
    e && e.stopPropagation()
    const { placeData, amplitudeEventTrack } = this.props
    amplitudeEventTrack('swipe.top.image.source', trackingShareProperty(placeData))
  }
}

export default compose(
  withBeacon,
  withTranslation(),
  getContext({
    isApp: PropTypes.bool.isRequired,
    placeType: PropTypes.string.isRequired,
  }),
)(PlaceImageBlock)
